import React, { FC, useState } from 'react';
import { generatePath, useHistory, useParams } from 'react-router-dom';
import { LIST_ANALYTICS_CHAPTERS } from '../../../../../../routes/routeConstants/appRoutes';
import AnalyticsCard from './ AnalyticsCard';
import SubjectsAnalyticsCard from './SubjectsAnalyticsCards';
export const InstituteStudentAnalytics: FC = () => {
    const history = useHistory();
    const params = useParams()
  const [selected, setSelected] = useState("subject");
    return (
        <div className="institute-student__analytics">
            {/* <AnalyticsCard showPaper={false}/> */}
            {(selected == "subject" || selected == "paper") && <AnalyticsCard showPaper={selected == "paper"}/>}

        <SubjectsAnalyticsCard
          onClick={(id: any, name: string) => {
            history.push({
              pathname: generatePath(LIST_ANALYTICS_CHAPTERS, {
                subjectId: id,
                ...params
              }),
              state: {
                subjectId: id,
                subjectName: name,
              },
            });
          }}
        />

        </div>
    )
}
